import { Inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Environment } from '@desbank/core/src/lib/environment';
import { StorageService } from '@desbank/core/src/lib/services/storage';

@Injectable({
  providedIn: 'root'
})
export class LoggedGuard implements CanActivate {

  constructor(
    private storageService: StorageService,
    @Inject('environment') private env: Environment
  ) {}

  canActivate(): boolean {
    return Boolean(this.storageService.getSession(this.env.authKey));
  }
}
